import { z } from 'zod'

export const paramsSchema = z.object({
  province_slug: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
